import keyMirror from 'keymirror';

export const FetchStaticsActionTypes = keyMirror({
  FETCH_STATIC: undefined,
  FETCH_STATIC_SUCCESSFUL: undefined,
});

